










import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import Button from 'frontend/components/Button.vue';
import { smoothScrollTo } from 'frontend/utils/scroll';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    Button,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class GiftPaywallFooter extends Vue {
  private readonly isMobile!: MobileGetter;

  private handleClick() {
    smoothScrollTo(0);
  }
}
